module.exports = __webpack_public_path__ + "static/img_1404-afb2da30581bf0cecb95a02496921546.webp";